// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Transition$Showside from "../utils/Transition.bs.js";
function Tooltip(Props) {
  var text = Props.text;
  var showOpt = Props.show;
  var direction = Props.direction;
  var show = showOpt !== undefined ? showOpt : false;
  var tmp;
  switch (direction) {
    case /* Top */0:
      tmp = "left-1/2 -translate-x-1/2 bottom-full";
      break;
    case /* Bottom */1:
      tmp = "left-1/2 -translate-x-1/2 top-full";
      break;
    case /* Left */2:
      tmp = "top-1/2 -translate-y-1/2 right-full";
      break;
    case /* Right */3:
      tmp = "top-1/2 -translate-y-1/2 left-full";
      break;
    case /* BottomRight */4:
      tmp = "right-0 top-full";
      break;
    case /* BottomLeft */5:
      tmp = "left-0 top-full";
      break;
  }
  var tmp$1;
  switch (direction) {
    case /* Top */0:
      tmp$1 = "mb-4";
      break;
    case /* Left */2:
      tmp$1 = "mr-4";
      break;
    case /* Right */3:
      tmp$1 = "ml-4";
      break;
    case /* Bottom */1:
    case /* BottomRight */4:
    case /* BottomLeft */5:
      tmp$1 = "mt-4";
      break;
  }
  var tmp$2;
  var exit = 0;
  switch (direction) {
    case /* Top */0:
    case /* Bottom */1:
      exit = 2;
      break;
    case /* Left */2:
    case /* Right */3:
      exit = 1;
      break;
    case /* BottomRight */4:
      tmp$2 = React.createElement("div", {
        className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
        style: {
          bottom: "auto",
          right: "16px",
          top: "-11px",
          clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
        }
      });
      break;
    case /* BottomLeft */5:
      tmp$2 = React.createElement("div", {
        className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
        style: {
          bottom: "auto",
          left: "16px",
          top: "-11px",
          clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
        }
      });
      break;
  }
  switch (exit) {
    case 1:
      tmp$2 = React.createElement("div", {
        className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
        style: {
          left: direction === /* Right */3 ? "-11px" : "auto",
          right: direction === /* Right */3 ? "auto" : "-11px",
          top: "50%",
          clipPath: direction === /* Right */3 ? "polygon(100% 0, 50% 50%, 100% 100%)" : "polygon(0 0, 0 100%, 50% 50%)",
          transform: "translateY(-50%)"
        }
      });
      break;
    case 2:
      tmp$2 = React.createElement("div", {
        className: CSS$Showside.prefix("absolute w-4 h-4 bg-primary"),
        style: {
          bottom: direction === /* Bottom */1 ? "auto" : "-11px",
          left: "50%",
          top: direction === /* Bottom */1 ? "-11px" : "auto",
          clipPath: direction === /* Bottom */1 ? "polygon(50% 50%, 0% 100%, 100% 100%)" : "polygon(50% 50%, 0 0, 100% 0)",
          transform: "translateX(-50%)"
        }
      });
      break;
  }
  return React.createElement(Transition$Showside.make, {
    show: show,
    enterFrom: CSS$Showside.prefix("opacity-0"),
    enterTo: CSS$Showside.prefix("opacity-100"),
    leaveFrom: CSS$Showside.prefix("opacity-100"),
    leaveTo: CSS$Showside.prefix("opacity-0"),
    className: CSS$Showside.prefix(Cn.make(["z-10 absolute bg-primary text-main rounded-custom opacity-0 whitespace-nowrap shadow-lg px-3 py-2 text-base transform transition-all duration-150", tmp, tmp$1, "pointer-events-none"])),
    children: null
  }, tmp$2, text);
}
Tooltip.displayName = "Tooltip";
var make = Tooltip;
export { make };
/* react Not a pure module */